import type { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";

export const DASHBOARD_TYPE = "TableWebsiteKeywordsDashboard";
export const INITIAL_SORT = { sort: "share", asc: false };
export const PAGE_SIZE = 100;

export const SourceTypeMap: Record<keyof typeof EKeywordTabs, string> = {
    Total: "all",
    Organic: "organic",
    Paid: "paid",
};
